import React, { useState } from 'react';
import { Popper, ClickAwayListener, Paper, Fade } from '@mui/material';

const Dropdown = ({ anchorEl, open, onClose, children, PaperProps, ...otherProps }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);

    setTimeout(() => {
      onClose();
      setClosing(false);
    }, 200);
  };

  return (
    <Popper
      anchorEl={anchorEl}
      open={open && !closing}
      onClose={onClose}
      transition
      {...otherProps}
    >
      {({ TransitionProps }) => (
        <ClickAwayListener onClickAway={handleClose}>
          <Fade {...TransitionProps} timeout={200}>
            <Paper elevation={6} square data-testid="dropdown-container" {...PaperProps}>
              <div>{children}</div>
            </Paper>
          </Fade>
        </ClickAwayListener>
      )}
    </Popper>
  );
};

export default Dropdown;
